import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from '../../model-base';
import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';

import { NowAccountBadgesCollection } from './models/badges';

@Injectable()
export class NowAccountSummaryApi {
    public static getNowAccountBadges(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<NowAccountBadgesCollection> {
        return http.get('/now/badges/products/mobile', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: ApiResponse) =>
                NowAccountBadgesCollection.create<NowAccountBadgesCollection>({ ...response, status: params.status }))
        );
    }

}

ModelBase.fetchMapping[StoreAction.GET_NOW_ACCOUNT_BADGES] = NowAccountSummaryApi.getNowAccountBadges;
